import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const AiPerformancePage = lazy(() => import('~/features/ai-performance/pages/ai-performance-page'));

/**
 * `productId` opens the per-product drill-down drawer. It lives in the URL rather than in
 * component state so the drawer is addressable — any surface that names a product can
 * link straight into it, and a shared link reopens the same product.
 */
const searchSchema = z.object({
  productId: z.string().min(1).optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/ai-performance/$workflowId')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

/**
 * AI Performance Insights for one enrichment run. The route owns URL state (run id and
 * the drill-down's product id); every fetch, panel and empty state lives in the page.
 */
function RouteComponent() {
  const { workflowId } = Route.useParams();
  const { productId } = Route.useSearch();
  const navigate = useNavigate({ from: '/ai-performance/$workflowId' });

  return (
    <Suspense fallback={<PageSkeleton />}>
      <AiPerformancePage
        workflowId={workflowId}
        productId={productId}
        onProductIdChange={(next) => {
          void navigate({
            search: next === undefined ? {} : { productId: next },
            replace: true,
          });
        }}
      />
    </Suspense>
  );
}
